export default __webpack_public_path__ + "static/media/visual_03.8989fdd1.png";